// Generated from SVG to Code Figma Plugin

export const ArrowUp = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g opacity="0.7">
      <path
        d="M11.1711 4.36968L11.1711 4.36968C11.3745 4.15351 11.7147 4.1432 11.9309 4.34665C12.1471 4.55011 12.1574 4.89028 11.9539 5.10645L7.49963 9.83911C7.18578 10.1726 6.66102 10.1885 6.32755 9.87463L6.32755 9.87463L6.32682 9.87394L6.31446 9.86201L6.31439 9.86208L6.31149 9.859L1.83776 5.10645L1.83776 5.10645C1.6343 4.89028 1.64461 4.55011 1.86078 4.34666L1.8607 4.34656L1.86454 4.34329L1.89866 4.31428L1.89858 4.31418L1.90261 4.31109C2.11893 4.14531 2.42979 4.16698 2.62057 4.36968L6.89612 8.91232L11.1711 4.36968Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.2"
      />
    </g>
  </svg>
);
